module.exports = __webpack_public_path__ + "static/media/rosquality.61b4967c.png";